<template>
  <div class="shopping-card">
    <div class="shopping-card-content">
      <div class="shoppping-card-col-img">
        <img class="shopping-card-header" :src="coupleImage" />
      </div>
      <div class="shoppping-card-col-content">
        <div class="shopping-card-title">
          <img class="" :src="shoppingCart" />Shopping Casar.com
        </div>
        <div class="shopping-card-bold-text">
          Pensando em adicionar uma lista externa para receber produtos para sua
          casa? Conheça o Shopping Casar.com!
        </div>
        <div class="shopping-card-simple-text">
          Com ele vocês podem utilizar o saldo da lista de presentes para
          comprar produtos para casa e ganhar
          <span style="color: #e583a2">4% de cashback</span> em cada compra.
        </div>
        <div class="shopping-card-banner"></div>
        <a
          href="/carteira?go=shopping"
          target="_blank"
          class="shopping-card-banner-link"
        >
          Conhecer o Shopping Casar.com <img :src="arrowRightLink" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import coupleImage from '@/assets/img/couple-using-shopping.png'
import shoppingCart from '@/assets/img/shopping-cart.svg'
import arrowRightLink from '@/assets/img/chevron-right-link.svg'

export default {
  data() {
    return {
      coupleImage,
      shoppingCart,
      arrowRightLink,
    }
  },
}
</script>

<style lang="scss" scoped>
.shopping-card {
  width: 100%;
  margin: 0 auto 32px;
  padding: 32px;
  border-radius: 16px;
  text-align: center;
  background-color: rgba(237, 191, 207, 0.2);
  @media screen and (min-width: 768px) and (max-width: 1919px) {
    max-width: 100%;
    text-align: left;
  }

  @media screen and (min-width: 1920px) {
    max-width: 320px;
    padding: 16px 32px;
  }

  @media screen and (min-width: 1920px) and (min-height: 710px) {
    position: sticky;
    top: 100px;
    height: 610px;
    margin: 0 auto 75px;
  }
}

.shopping-card-content {
  max-width: 320px;
  margin: 0 auto;
  @media screen and (min-width: 768px) and (max-width: 1919px) {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 64px;
    max-width: 740px;
  }
}

.shopping-card-title {
  margin-top: 14px;
  color: $primary;
  font-weight: 700;
  font-size: 16px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  @media screen and (min-width: 768px) and (max-width: 1919px) {
    justify-content: flex-start;
    gap: 8px;
    margin-top: 0;
  }
}
.shopping-card-header {
  min-width: 218px;
  @media screen and (min-width: 768px) and (max-width: 1919px) {
    justify-content: flex-start;
  }
}
.shopping-card-bold-text {
  margin-top: 16px;
  color: $neutral;
  font-weight: 700;
  font-size: 16px;
}

.shopping-card-simple-text {
  margin-top: 16px;
  color: $neutral;
  font-size: 14px;
}
.shopping-card-banner {
  margin-top: 16px;
  max-width: 250px;
  width: 100%;
  height: 60px;
  display: inline-block;
  background-size: 100%;
  background-repeat: no-repeat;
  background-image: url('~@/assets/img/banners-external-list.png');
  @media screen and (min-width: 768px) and (max-width: 1919px) {
    max-width: 100%;
    height: 27px;
    background-image: url('~@/assets/img/banners-external-list-wide.png');
  }
}
.shopping-card-banner-link {
  margin-top: 16px;
  color: $primary;
  display: flex;
  font-weight: 700;
  font-size: 16px;
  justify-content: center;
  @media screen and (min-width: 768px) and (max-width: 1919px) {
    justify-content: flex-start;
  }
}
</style>
